let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c8QnK")).then(() => parcelRequire('5eEqc'));